import styleProfile from "../style-profile";
import { customLogger } from "@/utils";
const store = require("../store").default;
import { i18n } from "../lang";
const ss = require("@/services/socket");


const moveToFinalQcm = async () => {
    try {
        let canMoveFinalQcm = false;
        const expected_work_hours =
            store.state.user.data?.subscription?.expected_work_hours;
        const time_consumed = store.state.user.user_session?.total_time_spent;
        if (store.state.user?.data?.qcm_results?.length && time_consumed) {
            canMoveFinalQcm =
                Object.keys(store.state.user?.data?.qcm_results).length >= 10 &&
                time_consumed >= expected_work_hours;
        }

        if (canMoveFinalQcm) {
            styleProfile.generateNextStyleProfileStep("before_ending");
        } else {
            const expected_time =
                store.state.user.data.subscription.expected_work_hours /
                3600000; // converted to hours
            customLogger("expected_time", expected_time);
            await store
                .dispatch("SET_MODAL", {
                    body: `Pour continuer, vous devez passer au moins ${expected_time} heures en formation et finir les 10 points clés.`,
                    type: "warning",
                })
                .then(async () => {
                    styleProfile.generateNextStyleProfileStep("start_quizz");
                });
        }
    } catch (e) {
        throw e;
    }
};

//this function is called when the user clicks on the "Home" button in the style profile
//it sets the mode to "style_profile" and generates the next step in the style profile
export const backToStepStarter = () => {
    const doneSteps = Object.keys(store.state.user.data);

    if (
        store.state.user.data.last_step === "user_choice" ||
        (doneSteps.includes("user_choice") &&
            !doneSteps.includes("biens_ending1"))
    ) {
        store.commit("SET_MODE", "style_profile");
        styleProfile.generateNextStyleProfileStep("user_choice");
        const step =
            store.state.config.steps[store.state.user.style_profile_key];
        if (step.page_title.title) {
            store.dispatch("setPageTitle", step.page_title.title);
        }
        if (step.page_title.subtitle) {
            store.dispatch("setPageSubtitle", step.page_title.subtitle);
        }
        sectionMessageIndecator(store.state.user.style_profile_prev_key);
    }
};

export const sectionMessageIndecator = (curr_step) => {
    const At = new Date();
    if (curr_step == "biens3" || curr_step == "biens_ending3") {
        store.commit("PUSH_MESSAGE", {
            sender_type: "bot",
            content: {
                message: `<strong>2. La propriété</strong>`,
            },
            typing_indicator: false,
            sent_at: At.toISOString(),
        });
    } else if (curr_step == "propriete7" || curr_step == "proriete_ending7") {
        // push a message
        store.commit("PUSH_MESSAGE", {
            sender_type: "bot",
            content: {
                message: `<strong>3. Vente et Baux</strong>`,
            },
            typing_indicator: false,
            sent_at: At.toISOString(),
        });
    } else if (curr_step == "vente2" || curr_step == "vente_ending2") {
        // push a message
        store.commit("PUSH_MESSAGE", {
            sender_type: "bot",
            content: {
                message: `<strong>4. Baux Commerciaux</strong>`,
            },
            typing_indicator: false,
            sent_at: At.toISOString(),
        });
    } else if (curr_step == "vente3" || curr_step == "vente_ending3") {
        // push a message
        store.commit("PUSH_MESSAGE", {
            sender_type: "bot",
            content: {
                message: `<strong>5. Formalisme du mandat : Préalable</strong>`,
            },
            typing_indicator: false,
            sent_at: At.toISOString(),
        });
    } else if (
        curr_step == "baux1" ||
        curr_step == "baux1_ending1"
    ) {
        // push a message
        store.commit("PUSH_MESSAGE", {
            sender_type: "bot",
            content: {
                message: `<strong>6. Formalisme du Mandat : Duree</strong>`,
            },
            typing_indicator: false,
            sent_at: At.toISOString(),
        });
    } else if (
        curr_step == "mandat_prealable1" ||
        curr_step == "mandat_prealable_ending1"
    ) {
        // push a message
        store.commit("PUSH_MESSAGE", {
            sender_type: "bot",
            content: {
                message: `<strong>7. Formalisme du Mandat : Registre</strong>`,
            },
            typing_indicator: false,
            sent_at: At.toISOString(),
        });
    } else if (
        curr_step == "mandat_duree1" ||
        curr_step == "mandat_duree_ending1"
    ) {
        // push a message
        store.commit("PUSH_MESSAGE", {
            sender_type: "bot",
            content: {
                message: `<strong>8. Exécution et reddition & Rémunération de l'intermédiaire</strong>`,
            },
            typing_indicator: false,
            sent_at: At.toISOString(),
        });
    }
};

export const CheckFormacastFinishConditions = async () => {
    try {
        customLogger("CheckFormacastFinishConditions------->");
        customLogger("redirect to final qcm");
        await store.dispatch("UPDATE_FINISH_CONDITIONS");
        store.state.user.user_session.finishes_conditions = true;
        if (store.state.user.data.subscription.method == "monthly") {
          await store
            .dispatch("SET_MODAL", {
              body: i18n.get().tc("chat.finish_conditions"),
              type: "info",
            })
            .then(() => {
              styleProfile.generateNextStyleProfileStep("biens_ending1");
            });
        } else {
          await store.dispatch("STOP_SUBSCRIPTION", {
            message: i18n.get().tc("chat.sub_stop"),
          });
        }
    } catch (error) {
        customLogger("CheckFormacastFinishConditions------->", error);
    }
};

export const Force10PointsToFinish = async () => {
  const method = store.state.user.data.subscription.method;
  const expected_work_hours =
    parseInt(store.state.user.data.subscription.expected_work_hours) / 3600000;
  customLogger("Force10PointsToFinish------->", method);
  const timeLimitString = (time = "14") => {
    if (method == "monthly") {
      return `Vous avez atteint ${time}h d'utilisation, nous vous invitons à consulter les 10 points clés pour terminer votre formation.`;
    }
    return `Vous avez atteint 60 jours d'utilisation, nous vous invitons à consulter les 10 points clés pour terminer votre formation avant d'accéder au QCM final.`;
  };
  try {
    customLogger("Force10PointsToFinish------->");
    await store
      .dispatch("SET_MODAL", {
        body: timeLimitString(expected_work_hours),
        type: "info",
      })
      .then(async () => {
        await store.commit("SET_BLOCKING_MODAL", true);
        styleProfile.generateNextStyleProfileStep("start_quizz");
      });
  } catch (error) {
    customLogger("Force10PointsToFinish------->", error);
  }
};

export const SesstionExpired = async () => {
    try {
        customLogger("SesstionExpired------->");
        customLogger("redirect to subscription page");

        if (store.state.user.data.subscription.method == "unique") {
          await store.dispatch("PAYMENT_EXPIRED").then(async () => {
            store.state.user.subscription = undefined;
            await store.commit("SHOW_SUBS_FLOW", true);
            const timeLimit =
              parseInt(store.state.data.subscription.expected_work_hours) /
              3600000;
            const limitString = (time) => {
              if (typeof time === "number")
                return (
                  i18n.get().tc("subscription.sesstion_expired_time") +
                  " " +
                  time +
                  "H"
                );
              return i18n.get().tc("subscription.sesstion_expired_time");
            };
            await store
              .dispatch("SET_MODAL", {
                body: limitString(timeLimit),
                type: "error",
              })
              .then(() => {
                styleProfile.generateNextStyleProfileStep("biens_ending1");
              });
          });
        }else if ( store.state.user.data.subscription.method == "monthly") {
          await store.dispatch("REFRESH_USER").then(async () => {
          
            const timeLimit =
            parseInt(store.state.user.data.subscription.expected_work_hours) /
            3600000;
            const limitString = (time) => {
              if (typeof time === "number")
                return (
                  i18n.get().tc("subscription.refresh_user") +
                  " : " +
                  time +
                  "H"
                );
              return i18n.get().tc("subscription.refresh_user");
            };
            await store
              .dispatch("SET_MODAL", {
                body: limitString(timeLimit),
                type: "info",
              })
              .then(async () => {
                store.state.user.user_session.total_time_spent = 60;
                store.state.user.user_session.finishes_conditions = false;
                delete store.state.user.data.last_step;
                customLogger("SesstionExpired------->", store.state)
                await store.dispatch("FETCH_USER_DATA", true);
                await store.dispatch("FETCH_USER_MESSAGES");

              });
          });
        }
    } catch (error) {
        customLogger("SesstionExpired------->", error);
    }
};

 export const formacastLogicMessage = async ({ text, value, action, ai_question, live_coach_question, text_without_t, to_send, last_step, tmp_content}) => {
    const lang = store.state.user.lang;
    if (value == "start_course") {
      store.commit("PUSH_MESSAGE", {
        sender_type: "bot",
        content: {
          message: "Vous avez choisi de commencer le cours, on commence par le QCM d'entrée",
          alone: true,
        },
        typing_indicator: false,
      });
      store.commit("PUSH_MESSAGE", {
        sender_type: "bot",
        content: {
          message: `<strong>1. Les biens</strong>`,
          alone: true,
        },
        typing_indicator: false,
      });
    }
      const step =
              store.state.config.steps[store.state.user.style_profile_key];
      customLogger("formacastLogicMessage -> step", step);
      try {
          if(step?.page_title?.title) {
            store.dispatch('setPageTitle', step.page_title.title);
          }
          if(step?.page_title?.subtitle) {
            store.dispatch('setPageSubtitle', step.page_title.subtitle);
          }
          sectionMessageIndecator(store.state.user.style_profile_prev_key)
          if(step?.on_click?.showBoxEmail){
            const At = new Date();
            store.commit("PUSH_MESSAGE", {  
              sender_type: "bot",
              content: {
                message: 'chat.not_here',
                skip_to: 'done'
              },
              sent_at: At.toISOString(),
              typing_indicator: false,
            });
          }else if (action == "live_coach_generate_questions"){
            store.state.user.loading_indicator = true
            await ss.socket.emit("live_coach_generate_questions",{
              question: live_coach_question,
              store_id : store.state.config.storeId,
              level: store.state.user?.data?.intro_exit_results?.SAI?.level || 1,
              lang: store.state.user.lang,
              step_value: "live_coach_generate_questions",
            }, (data) => {
              // handle errors
              if (data.error) {
                customLogger("formacastLogicMessage -> data.error", data.error);
                store.state.user.loading_indicator = false
                const At = new Date();
                store.commit("PUSH_MESSAGE", {  
                  sender_type: "bot",
                  content: {
                    message: 'chat.not_here',
                  },
                  sent_at: At.toISOString(),
                  typing_indicator: false,
                });
                return;
              }
              return;
            });  
          }else if (action == "generate_questions") {
              
              const At = new Date();
              await store.commit("PUSH_MESSAGE", {  
                sender_type: "self",
                content: {
                  message: ai_question,
                },
                sent_at: At.toISOString(),
                typing_indicator: false,
              });
              await ss.socket.emit("generate_questions",{
                ai_question,
                step_value: value,  
                current_step: text,
                store_id : store.state.config.storeId,
                level: store.state.user?.data?.intro_exit_results?.SAI?.level || 1,
                lang: store.state.user.lang
              }, (data) => {
                // handle errors
                if (data.error) {
                  customLogger("formacastLogicMessage -> data.error", data.error);
                  store.state.user.loading_indicator = false
                  const At = new Date();
                  store.commit("PUSH_MESSAGE", {  
                    sender_type: "bot",
                    content: {
                      message: 'chat.not_here',
                    },
                    sent_at: At.toISOString(),
                    typing_indicator: false,
                  });
                  return;
                }
                return;
              });  
              
          } else if (action == "10question_next_step") {
            moveToFinalQcm()
          }
          else if (step?.on_click?.qcm_calculation?.action && step?.on_click?.qcm_calculation?.name && step?.on_click?.qcm_calculation?.next_step) {
              store.state.user.loading_indicator = true
              await ss.socket.emit("generate_questions_results", {
                action: step?.on_click?.qcm_calculation?.action,
                name: step?.on_click?.qcm_calculation?.name,
                userId: store.state.user.id,
                expected_work_hours: store.state.user.data.subscription.expected_work_hours,
                lang
              }, (data) => {
                // handle errors
                if (data.error) {
                  customLogger(data.error);
                  store.state.user.loading_indicator = false
                  return;
                }
                // update intro_exit_results in data 
                if (data.intro_exit_results) {
                  store.commit("SET_DATA", { intro_exit_results: data.intro_exit_results });
                  customLogger(store.state.user.data)
                }
                customLogger(`> Qcm ${step?.on_click?.qcm_calculation?.name} is calculated and the next step is ${step?.on_click?.qcm_calculation?.next_step}`);
                styleProfile.generateNextStyleProfileStep(step?.on_click?.qcm_calculation?.next_step);
                store.state.user.loading_indicator = false
              })
          } else if (text_without_t == "chat.openai.buttons.cancel") {
            styleProfile.generateNextStyleProfileStep("user_choice")
          } else {
            styleProfile.generateNextStyleProfileStep(
              tmp_content ? tmp_content : value ? value : text_without_t,
              to_send,
              last_step
            );
          }
          return "done"
      } catch (e) {
          customLogger("formacastLogicMessage -> e", e);
          throw e;
      }
  }
